<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" style="width:500px;" v-if="!hasFeature('configModal')">
          <div>
            <v-card-title class="headline"><v-icon color="error" class="mr-3">mdi-alert</v-icon>Terminal not authorised!</v-card-title>
            <v-card-text>
              This terminal is not authorised, please contact support.
              <br><br>
              <span style="color:red">Terminal ID: {{terminalId}}</span>
              <br>
              <br>
              <span style="color:red">{{failMsg.response.data.message}} <br> {{failMsg}}</span>
              <br><br>
              You will be signed out on close
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn elevation="0"
                color="blue darken-1"
                text
                @click="$emit('close')"
              >
                CLOSE
              </v-btn>
            </v-card-actions>
          </div>
        </div>
        <div class="modal-container" style="width:500px;" v-else>
          <div>
            <v-card-title class="headline"><v-icon color="error" class="mr-3">mdi-alert</v-icon>Terminal not authorised!</v-card-title>
            <v-card-text>
              This terminal is not authorised, please enrol terminal with Technician
              <br><br>
              <span style="color:red">Terminal ID: {{terminalId}}</span>
              <br>
              <br>
              <span style="color:red">{{failMsg.response.data.message}} <br> {{failMsg}}</span>
              <br><br>
              You will be signed out on close
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn elevation="0"
                color="success"
                text
                @click="openEnrol()"
              >
                Enrol
              </v-btn>
              <v-btn elevation="0"
                color="error"
                text
                @click="$emit('close')"
              >
                CLOSE
              </v-btn>
            </v-card-actions>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TemrinalFailModal',
  props: {
    terminalId: String,
    failMsg: Error
  },
  computed: {
    ...mapGetters(['hasFeature']),
  },
  methods: {
    openEnrol () {
      this.$router.push({ path: `/enrolTerminal/${this.terminalId}` }),
      this.$emit('close') 
    }
  }
}
</script>

<style>

</style>
